module.exports = __webpack_public_path__ + "static/media/chartered.1a1436c5.png";